module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	methods: {
		onChange: function(){
			var self = this;
			self.model.filterAttributes = ((self.model.dirtyFields || {}).data || {}).attributes || {};
			if(!self.model.tagAssignment){
				self.closest('base_tags_tagAssignment', function(tagAssignment){
					self.model.tagAssignment = tagAssignment;
				});
			}
			if(self.model.tagAssignment){
				self.model.tagAssignment.filter(self.model.filterAttributes);
			}
		}
	}

}